package br.com.texeratx.boardgametimeapp.ui.screens.reset_password

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.text.ClickableText
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Visibility
import androidx.compose.material.icons.filled.VisibilityOff
import androidx.compose.material3.Button
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp
import br.com.texeratx.boardgametimeapp.core.i18n.LocalStrings
import br.com.texeratx.boardgametimeapp.ui.components.AuthCardLayout

@Composable
fun ResetPasswordUI(
    state: ResetPasswordUiState,
    onEmailChange: (String) -> Unit,
    onCodeChange: (String) -> Unit,
    onNewPasswordChange: (String) -> Unit,
    onConfirmPasswordChange: (String) -> Unit,
    onSubmitClick: () -> Unit,
    onBack: () -> Unit
) {
    val S = LocalStrings.current
    var showNewPassword by remember { mutableStateOf(false) }
    var showConfirmPassword by remember { mutableStateOf(false) }

    val canSubmit = state.email.isNotBlank() &&
            state.code.length == 6 &&
            state.newPassword.isNotBlank() &&
            state.confirmPassword.isNotBlank() &&
            !state.isLoading

    AuthCardLayout {
        Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {

            Text(S.resetPasswordTitle, style = MaterialTheme.typography.headlineSmall)

            Text(
                S.resetPasswordInstructions,
                style = MaterialTheme.typography.bodyMedium
            )

            OutlinedTextField(
                value = state.email,
                onValueChange = onEmailChange,
                label = { Text(S.labelEmail) },
                modifier = Modifier.fillMaxWidth(),
                singleLine = true,
                enabled = state.email.isEmpty()
            )

            OutlinedTextField(
                value = state.code,
                onValueChange = onCodeChange,
                label = { Text(S.label6DigitCode) },
                modifier = Modifier.fillMaxWidth(),
                singleLine = true,
                placeholder = { Text(S.placeholderCode) }
            )

            OutlinedTextField(
                value = state.newPassword,
                onValueChange = onNewPasswordChange,
                label = { Text(S.labelNewPassword) },
                modifier = Modifier.fillMaxWidth(),
                singleLine = true,
                visualTransformation = if (showNewPassword) VisualTransformation.None else PasswordVisualTransformation(),
                trailingIcon = {
                    IconButton(onClick = { showNewPassword = !showNewPassword }) {
                        Icon(
                            imageVector = if (showNewPassword) Icons.Default.VisibilityOff else Icons.Default.Visibility,
                            contentDescription = if (showNewPassword) S.hidePassword else S.showPassword
                        )
                    }
                }
            )

            OutlinedTextField(
                value = state.confirmPassword,
                onValueChange = onConfirmPasswordChange,
                label = { Text(S.labelConfirmNewPassword) },
                modifier = Modifier.fillMaxWidth(),
                singleLine = true,
                visualTransformation = if (showConfirmPassword) VisualTransformation.None else PasswordVisualTransformation(),
                trailingIcon = {
                    IconButton(onClick = { showConfirmPassword = !showConfirmPassword }) {
                        Icon(
                            imageVector = if (showConfirmPassword) Icons.Default.VisibilityOff else Icons.Default.Visibility,
                            contentDescription = if (showConfirmPassword) S.hidePassword else S.showPassword
                        )
                    }
                }
            )

            Button(
                onClick = onSubmitClick,
                enabled = canSubmit,
                modifier = Modifier.fillMaxWidth()
            ) {
                if (state.isLoading) {
                    CircularProgressIndicator(
                        color = MaterialTheme.colorScheme.onPrimary,
                        modifier = Modifier.size(20.dp)
                    )
                    Spacer(Modifier.width(12.dp))
                    Text(S.resetting)
                } else {
                    Text(S.resetPassword)
                }
            }

            state.error?.let {
                Text(it, color = MaterialTheme.colorScheme.error)
            }

            ClickableText(
                text = AnnotatedString(S.back),
                style = MaterialTheme.typography.bodyMedium.copy(color = MaterialTheme.colorScheme.primary),
                onClick = { onBack() }
            )
        }
    }
}
